import { IgTypography } from "@intelligems/ig-theme";
import { MenuItem, Stack } from "@mui/material";

import { NavigationItem } from "../types";
import React from "react";
import { useSelector } from "react-redux";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

interface NavigatorOptionProps {
  props: React.HTMLAttributes<HTMLLIElement> & { key: string };
  option: NavigationItem;
}

export const NavigatorOption = ({ props, option }: NavigatorOptionProps) => {
  const path = useSelector(ExperienceBuilderSelector.getLastPath);
  const { key, ...optionProps } = props;
  const isActive = option.path === path;

  return (
    <MenuItem
      key={key}
      {...optionProps}
      sx={{
        height: 48,
        fontWeight: isActive ? 600 : 400,
      }}
    >
      <Stack sx={{ minWidth: 0 }}>
        <IgTypography variant="body2" noWrap>
          {option.title}
        </IgTypography>
        {option.group && (
          <IgTypography
            variant="caption"
            noWrap
            sx={{ fontSize: 10, color: "text.disabled" }}
          >
            {option.path}
          </IgTypography>
        )}
      </Stack>
    </MenuItem>
  );
};
